module.exports = __webpack_public_path__ + "static/img/researcherPageArea.f9d0c46.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/researcherPageArea.jpg
// module id = TpCd
// module chunks = 3